module.exports = {
  text: `Полы подземелья были чистыми. Это должно было стать для нас первой подсказкой`,
  author: `Из дневника Джастера Холлоуквилла о своем первом исследовании Подгорья`,
}
